import type { DrawerProps as MantineDrawerProps } from '@mantine/core';
import { Drawer as MantineDrawer } from '@mantine/core';
import { memo } from 'react';
import styled, { css } from 'styled-components';

const Drawer = ({
  position = 'right',
  children,
  size = 520,
  title,
  ...props
}: MantineDrawerProps) => {
  return (
    <MantineDrawer.Root
      position={position}
      size={size}
      zIndex={1000}
      {...props}
    >
      <MantineDrawer.Overlay backgroundOpacity={0.5} />
      <StyledMantineDrawerContent
        aria-label={typeof title === 'string' ? title : undefined}
      >
        {children}
      </StyledMantineDrawerContent>
    </MantineDrawer.Root>
  );
};

const StyledMantineDrawerContent = styled(MantineDrawer.Content)`
  .mantine-Drawer-content {
    display: flex;
    flex-direction: column;
  }
`;

const Header = styled(MantineDrawer.Header)`
  ${({ theme }) => css`
    padding: ${theme.spacing(5, 5, 3, 5)};
    min-height: auto;
    align-items: flex-start;
  `}
`;

const Body = styled(MantineDrawer.Body)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    padding: ${theme.spacing(2, 5, 5, 5)};
  `}
`;

const Footer = styled.div`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.palette.neutral[60]};
    padding: ${theme.spacing(3, 5)};
    width: 100%;
    @media ${theme.mediaQueries.xs},
      ${theme.mediaQueries.sm},
      ${theme.mediaQueries.md} {
      padding: ${theme.spacing(3, 2)};
    }
  `}
`;

export default Object.assign(memo(Drawer), {
  Header: memo(Header),
  Body: memo(Body),
  Footer: memo(Footer),
  CloseButton: MantineDrawer.CloseButton,
});
